import { render, staticRenderFns } from "./CustomerInsuranceAddNew.vue?vue&type=template&id=fbdf5d7a&scoped=true&"
import script from "./CustomerInsuranceAddNew.vue?vue&type=script&lang=js&"
export * from "./CustomerInsuranceAddNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbdf5d7a",
  null
  
)

export default component.exports